module.exports = __webpack_public_path__ + "static/media/arrow-white.371950d3.svg";